import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Tip,
  Spinner,
  Nav,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Validate,
  Channel,
  Notification,
  Blog,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Slack,
  CircleAlert,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import Alert from "@material-ui/lab/Alert";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  TokenRefreshInterval,
  LogoutOktaURL,
  UIServerURL,
} from "./GlobalSettings";
import avtarPlaceholder from "../assets/user_placeholder.png";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import GetHelp from "./GetHelp";
//import Chatapplet from "./Chatapplet"
import UserInfo from "./UserInfo";
import ListView from "./ListView";
import InitialsAvatar from "react-initials-avatar";
import "react-initials-avatar/lib/ReactInitialsAvatar.css";
import EvtsForApprovals from "./EvtsForApprovals";
import UserdashboardApprovalDemos from "./UserdashboardApprovalDemos";
import SearchHandler from "./SearchHandler";
import Chatapplet from "./Chatapplet";
import VoucherPopup from "./VoucherGenerateForm";

class AppHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      UserInfo: auth.getUserInfo(),
      UserImg: auth.getImage(),
      bdisplayHelp: false,
      bOpenChat: false,
      bdisplayProf: false,
      searchSuggestionsData: undefined,
      searchValue: undefined,
      suggestions: undefined,
      stopShowingSuggestions: false,
      searchTobeObj: undefined,
      searchTobeVal: undefined,
      bshowSearch: false,
      bpopListItems: false,
      sessionExpireMessage: undefined,
      SystemData: undefined,
      ProdData: undefined,
      ProdDataLoaded: false,
      EvtsToBeApproved: undefined,
      bDisplayEvtApprovals: false,
      EvtsSpinner: false,
      IsBannerInfoViewed: false,
      BannerText: undefined,
      notificationON: true,
      isPartner: false,
      isEmpl: false,
      isCustomer: false,
      IsMainBannerToDisplay: true,
      bDisplayVoucher: false,
    };

    this._logout = this._logout.bind(this);
    this._setHelp = this._setHelp.bind(this);
    this.openChat = this.openChat.bind(this);
    this._setProfile = this._setProfile.bind(this);
    // this.loadSearchSuggestions = this.loadSearchSuggestions.bind(this);
    this._onSrchTextChange = this._onSrchTextChange.bind(this);
    this.closeList = this.closeList.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.getSystemSettingsData = this.getSystemSettingsData.bind(this);
    this.extractBannerMsg = this.extractBannerMsg.bind(this);
    this.bannerMessageRead = this.bannerMessageRead.bind(this);
    this.hideMainBannerDisplay = this.hideMainBannerDisplay.bind(this);
    this.OpenPSNow = this.OpenPSNow.bind(this);
    this.OpenTechPro = this.OpenTechPro.bind(this);
    this.OpenSlackHDP = this.OpenSlackHDP.bind(this);
    this._onSrchClick = this._onSrchClick.bind(this);
    this.goHome = this.goHome.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.checkUsrRoles = this.checkUsrRoles.bind(this);
    this.getEvtsToBeApprovedData = this.getEvtsToBeApprovedData.bind(this);
    this._openApprovals = this._openApprovals.bind(this);
    this._HideApprovals = this._HideApprovals.bind(this);
    this._hideSearch = this._hideSearch.bind(this);
    this.loadProds = this.loadProds.bind(this);
    this.closeSrchHandler = this.closeSrchHandler.bind(this);
    this._toggleVoucherPopup = this._toggleVoucherPopup.bind(this);
    //this._parseSuggestion=this._parseSuggestion.bind(this);
  }

  componentDidMount() {
    console.log("** From AppHeader Mount ", this.state.bDisplHelp);
    this.getSystemSettingsData();
    this.loadProds();
    // this.loadSearchSuggestions();
    //this.bannerMessageRead();
    this.checkUsrRoles();
    this.getEvtsToBeApprovedData();

    this._interval = setInterval(() => {
      if (!auth.loggedIn()) {
        this._logout();
        // this.props.router.replace('/login');
      } else if (!auth.verifyToken(false))
        this.setState({
          sessionExpireMessage: "Login will expire in 5 minutes.",
        });
      else this.setState({ sessionExpireMessage: undefined });
    }, TokenRefreshInterval);

    /*  this._interval2 = setInterval(() => {
      if (!auth.loggedIn()) {
        this._logout();
        // this.props.router.replace('/login');
      } else {
        this.extractBannerMsg();
      }
    }, TokenRefreshInterval); */

    //this._parseSuggestion();
  }

  componentWillUnmount() {
    clearInterval(this._interval);
    // clearInterval(this._interval2);
  }

  OpenPSNow() {
    console.log("Open PSNow clicked fired !!");
    window.open("https://psnow.ext.hpe.com", "_blank");
  }

  hideMainBannerDisplay() {
    this.setState({ IsMainBannerToDisplay: false, IsBannerInfoViewed: true });
  }

  closeSrchHandler() {}

  _toggleVoucherPopup() {
    this.setState((prevState) => ({
      bDisplayVoucher: !prevState.bDisplayVoucher,
    }));
  }

  OpenSlackHDP() {
    console.log("Open Slack HDP Internal clicked fired !!");
    if (this.state.isPartner) {
      console.log("User is Partner ? ", this.state.isPartner);
      window.open(
        "https://hpe.enterprise.slack.com/archives/C07UW6H11LJ",
        "_blank",
      );
    } else {
      window.open(
        "https://hpe.enterprise.slack.com/archives/C02779PMSKA",
        "_blank",
      );
    }
    /* window.open(
      "https://hpe-internal.slack.com/archives/C02779PMSKA",
      "_blank"
    ); */
  }

  checkUsrRoles() {
    var UsrDetails = auth.getUserInfo();
    var UsrRoles = UsrDetails.UserAppRoles;
    //var usrPart = null;

    console.log("UserRoles are ", UsrRoles);
    if (Array.isArray(UsrRoles) && UsrRoles.length > 0) {
      var usrEmp = UsrRoles.find((ur) => ur.AppRoleName == "HPE Employee");
      var usrPart = UsrRoles.find((ur) => ur.AppRoleName == "HPE Partner");
      var usrCust = UsrRoles.find((uc) => uc.AppRoleName == "HPE Customer");
      //var usrCust = UsrRoles.find((ur) => ur.AppRoleName == "HPE Customer");

      if (usrPart === undefined) {
        //console.log("This is either Employee or Customer", usrEmp);
        if (usrCust === undefined) {
          console.log("Now this is Employee");
          this.setState({ isEmpl: true });
        } else {
          this.setState({ isCustomer: true });
          console.log("Now this is Customer");
        }
        //console.log("This is Not Partner");
      } else {
        this.setState({ isPartner: true });
      }
      //console.log("This is Customer", usrCust);
    }
  }

  OpenTechPro() {
    console.log("Open TechPro clicked fired !!");
    window.open("https://techpro.hpe.com", "_blank");
  }

  bannerMessageRead() {
    // this.setState({ IsBannerInfoViewed: true });
    if (auth.getBannerMsgInStorage()) {
      if (auth.getBannerMsgInStorage() === this.extractBannerMsg()) {
        this.setState({ IsBannerInfoViewed: true });
      } else {
        this.setState({ IsBannerInfoViewed: false });
        auth.setBannerMsginStorage(this.extractBannerMsg());
      }
    } else {
      this.setState({ IsBannerInfoViewed: false });
      auth.setBannerMsginStorage(this.extractBannerMsg());
    }
  }

  startSearch() {
    console.log("StartSearch fired !!");
    if (this.state.searchTobeVal && this.state.searchTobeVal.length >= 4) {
      //console.log("StartSearch fired !!");
      this.setState({ bisListTobePoppedUp: true });
    }
  }

  closeList() {
    this.setState({
      bpopListItems: false,
      searchValue: undefined,
      searchTobeObj: undefined,
      searchTobeVal: undefined,
    });
    if (this.props.isRefreshing) {
      this.props.refreshCallBack();
    }
  }

  /* loadSearchSuggestions() {
    var endpoint = "/metadata/GetSearchPrefills";
    let token = auth.getToken();

    callApiGetJson(endpoint, token).then((data) => {
      //console.log('Suggestions data:' + data.toString());
      if (data !== undefined) {
        var searchsuggestions = new Array();
        this.setState({
          searchSuggestionsData: data,
        });
        data.map(function (item) {
          //console.log('Index: ' + item.MetadataType + '_' + item.MetadataID + ' - ' + item.MetadataName);
          searchsuggestions.push(item.MetadataName);
        });
        this.setState({ suggestions: searchsuggestions });
      }
    });
  } */

  getSystemSettingsData() {
    var endpoint = "/SystemSettings/GetBannerText";
    let token = auth.getToken();
    callApiGetJson(endpoint, token).then((data) => {
      console.log(data);
      this.setState({
        SystemData: data,
      });
    });
    console.log("Fetched from endpointvalue");
    console.log(this.state.SystemData);
  }

  loadProds() {
    var endpoint = "/Metadata/GetProducts";
    let token = auth.getToken();
    callApiGetJson(endpoint, token).then((data) => {
      console.log(data);
      this.setState({
        ProdData: data,
        ProdDataLoaded: true,
      });
    });
    console.log("Fetched from GetProds Metadata endpoint");
    console.log(this.state.ProdData);
  }

  getEvtsToBeApprovedData() {
    this.setState({ EvtsSpinner: true });
    var endpoint = "/Events/GetEventsToBeApproved";
    let token = auth.getToken();
    callApiGetJson(endpoint, token).then((data) => {
      console.log(data);
      this.setState({
        EvtsToBeApproved: data,
        EvtsSpinner: false,
      });
    });
    console.log("Fetched Any Pending Events to Be Approved");
    console.log(this.state.EvtsToBeApproved);
  }

  extractBannerMsg() {
    //this.getSystemSettingsData();
    var BannerMsg = [];
    var string1 = "";
    if (this.state.SystemData) {
      BannerMsg = this.state.SystemData.filter((dataRecord) => {
        if (dataRecord.SettingName.indexOf("Banner Message") >= 0) {
          string1 = dataRecord.SettingValue;
          //return dataRecord;
          return string1 !== null && string1 !== "" ? string1 : "";
        }
        return "";
      });
    }
    return string1;
  }

  _logout = () => {
    if (this.state.isPartner) {
      localStorage.removeItem("token");
      localStorage.removeItem("tokenexpires");
      localStorage.removeItem("email");
      localStorage.removeItem("userinfo");
      localStorage.removeItem("authenticated");
      localStorage.removeItem("userimgData");
      localStorage.removeItem("notificationcounter");
      localStorage.removeItem("noticecounterdateexp");
      localStorage.removeItem("recentpopup");
      //  localStorage.removeItem("");
      sessionStorage.clear();
      this.props.history.push("/");
    } else {
      var usrOktaIdtoken = localStorage.getItem("userOktaIDtoken");
      var fulllogoutURL =
        LogoutOktaURL +
        "?id_token_hint=" +
        usrOktaIdtoken +
        "&post_logout_redirect_uri=" +
        UIServerURL;
      localStorage.removeItem("token");
      localStorage.removeItem("tokenexpires");
      localStorage.removeItem("email");
      localStorage.removeItem("userinfo");
      localStorage.removeItem("authenticated");
      localStorage.removeItem("userimgData");
      localStorage.removeItem("userOktaIDtoken");
      localStorage.removeItem("notificationcounter");
      localStorage.removeItem("noticecounterdateexp");
      localStorage.removeItem("recentpopup");
      console.log("logout fired");
      console.log("Full Logout Okta URL is ", fulllogoutURL);
      window.location.replace(fulllogoutURL);
    }
    // this.props.history.push("/");
  };

  goHome() {
    this.props.history.push("/");
  }

  closeNotification() {
    this.setState({ notificationON: false });
  }

  _setHelp = () => {
    console.log("SetHelp Clicked");
    this.setState({ bdisplayHelp: true });
  };

  openChat() {
    this.setState({ bOpenChat: true });
  }

  _openApprovals = () => {
    console.log("Approval Evts Button Clicked");
    this.setState({ bDisplayEvtApprovals: true });
  };

  _HideApprovals = () => {
    this.setState({ bDisplayEvtApprovals: false });
    this.getEvtsToBeApprovedData();
  };
  _setProfile = () => {
    console.log("SetProfile Clicked");
    this.setState({ bdisplayProf: true });
  };

  _hideHelp = () => {
    console.log("SetHide Clicked");
    this.setState({ bdisplayHelp: false });
  };

  _hideProfile = () => {
    console.log("SetHide Profile Clicked");
    this.setState({
      UserDets: auth.getUserInfo(),
      bdisplayProf: false,
      notificationON: false,
    });
  };

  /*   _OnSrchTxtSelect(event) {
    console.log("On Search Text Select", event.suggestion);
    this.setState({ searchValue: event.suggestion });
    if (event.suggestion && this.state.searchSuggestionsData) {
      this.state.searchSuggestionsData.map((item) => {
        if (item.MetadataName === event.suggestion) {
          this.setState({ searchTobeObj: item, bpopListItems: true });
        }
      });
    }
  } */
  _onSrchClick() {
    //console.log("Search Click Clicked... with value ", this.state.searchValue);
    console.log("Search Click Clicked...");
    this.setState({ bshowSearch: true });
    /*     if (this.state.searchValue && this.state.searchValue.length >= 3) {
      var srchValue = this.state.searchValue;
      this.setState({ searchTobeVal: srchValue, bpopListItems: true });
    } */
  }

  _hideSearch() {
    this.setState({ bshowSearch: false });
  }

  _onSrchTextChange(event) {
    console.log("On Search Text Change ", event.target.value);
    console.log("On Search Key Press ", event.key);

    if (event.target.value !== "") {
      this.setState({ searchValue: event.target.value });
    } else {
      this.setState({ searchValue: undefined });
    }
    //var myret;

    /*     if (event.target.value !== "" && this.state.suggestions) {
      this.setState({ searchValue: event.target.value });
      myret = this.state.suggestions.filter((item) => {
        return (
          item.toLowerCase().indexOf(event.target.value.toLowerCase()) >= 0
        );
      });
      if (myret.length) {
        this.setState({ suggestions: myret });
      }
    } else {
      var updatedRet = new Array();
      this.state.searchSuggestionsData.map((item) => {
        updatedRet.push(item.MetadataName);
      });
      this.setState({ suggestions: updatedRet, searchValue: "" });
    } */

    if (event.target.value.length >= 3 && event.key === "Enter") {
      this.setState({ searchTobeVal: event.target.value, bpopListItems: true });
    }
  }

  render() {
    console.log("User Info at AppHeader is ", this.state.UserInfo);
    var uinfo = this.state.UserInfo;
    var uimg = this.state.UserImg;
    var bDisplHelp = this.state.bdisplayHelp;
    var bDisplProf = this.state.bdisplayProf;
    var bshowSearch = this.state.bshowSearch;
    var bSearchEnabled = this.state.ProdDataLoaded;
    var bIsYammer_SlackON = false;

    var ProdData = this.state.ProdData;

    var bDispApprovals = this.state.bDisplayEvtApprovals;

    var isEvtManagerObj = null;
    var isEventManager = false;

    isEvtManagerObj = this.state.UserInfo.UserRoleBasedActions.find(
      (x) => x.Action === "Approve_Deny_Event",
    );

    if (isEvtManagerObj !== undefined) {
      isEventManager = true;
    }

    console.log("Event Manager is ", isEvtManagerObj);
    console.log("Event Manager is there ", isEventManager);

    var isEvtsApprovedData =
      this.state.EvtsToBeApproved != undefined &&
      this.state.EvtsToBeApproved.length > 0
        ? true
        : false;

    var EvtsTBAPr =
      this.state.EvtsToBeApproved != undefined &&
      this.state.EvtsToBeApproved.length > 0
        ? this.state.EvtsToBeApproved
        : undefined;

    var isEvtsSpinner = this.state.EvtsSpinner;

    console.log(
      "From App Header  Evets TB Approved ",
      this.state.EvtsToBeApproved,
    );

    var FullName =
      this.state.UserInfo.FirstName + " " + this.state.UserInfo.LastName;

    var URactions = this.state.UserInfo
      ? this.state.UserInfo.UserRoleBasedActions
      : undefined;

    console.log("User Actions List is ", URactions);
    if (URactions) {
      var objFound = URactions.find((act) => {
        return act.Action === "Yammer_Thread_Click";
      });
      console.log("Found Action for Slack is", objFound);
      if (objFound && objFound.Action === "Yammer_Thread_Click") {
        bIsYammer_SlackON = true;
      }
    }

    var BannerMsg = this.extractBannerMsg();

    var that = this;

    var srchObj = this.state.searchTobeObj;
    var srchVal = this.state.searchTobeVal;
    var bisListTobePoppedUp = this.state.bpopListItems;

    console.log("From AppHeader - Free Text Srch Val is", srchVal);
    console.log("From AppHeader - Free Text Srch Object is", srchObj);

    if (bDisplHelp) {
      var HelpLoader = <GetHelp disp={bDisplHelp} />;
    }

    console.log("**From AppHeader");
    console.log(bDisplHelp);
    console.log("** From App Header Prof State", bDisplProf);

    var dottie = "brand";

    if (this.state.sessionExpireMessage) {
      dottie = "orange";
    }

    var bIsBannerMsgAlreadyRead = this.state.IsBannerInfoViewed;

    var bIsUserSubscribed = this.state.UserInfo.IsNL_Subscribed ? true : false;
    console.log("Is subscribed ", bIsUserSubscribed);

    var notifierTOShow = this.state.notificationON ? true : false;

    var isEmpl = this.state.isEmpl ? this.state.isEmpl : false;

    return (
      <Header
        //align="start"
        //direction="row"
        margin={{ top: "small" }}
        //flex="grow"
        fill="horizontal"
        // justify="start"
        gap="xsmall"
        background={{ color: "background-front" }}
        // margin={{ bottom: "medium" }}
        border={{ side: "bottom", style: "solid" }}
      >
        {bisListTobePoppedUp && (
          <ListView
            srchObj={srchObj}
            srchVal={srchVal}
            hide={this.closeList}
            calledBy="From Search"
          />
        )}
        {bDispApprovals && (
          <UserdashboardApprovalDemos
            Demos={EvtsTBAPr}
            hide={this._HideApprovals}
          />
        )}
        {bDisplProf && (
          <UserInfo
            display={bDisplProf}
            hide={this._hideProfile}
            UserDets={uinfo}
          />
        )}
        {bshowSearch && (
          <SearchHandler hide={this._hideSearch} Prods={ProdData} />
        )}
        {/* {!bDisplHelp ? ( */}

        <Box
          margin={{ left: "medium" }}
          onClick={this.goHome}
          direction="row"
          // align="center"
          justify="center"
        >
          <Hpe color="brand" />
          &nbsp;
          <Text weight="bold">HPE Demonstration Portal</Text>
        </Box>
        {BannerMsg && this.state.IsMainBannerToDisplay && (
          /*   <Box
            margin={{ bottom: "small" }}
            animation={{ type: "pulse", duration: 2000 }}
          >
            <Alert
              // variant="outlined"
              icon={<Notification fontSize="inherit" />}
              severity="success"
              //color="green"
              onClose={this.hideMainBannerDisplay}
            >
              {BannerMsg}
            </Alert>
          </Box> */
          <Box align="start" justify="center" direction="column">
            <Box
              align="center"
              justify="center"
              direction="column"
              background={{ color: "active" }}
              elevation="medium"
              round="xsmall"
            >
              <Text size="large" color="brand" margin="medium">
                {/* <mark background-color="brand" color="green"> */}
                {BannerMsg}
                {/* </mark> */}
              </Text>
            </Box>
          </Box>
        )}
        <Nav
          direction="row"
          justify="end"
          margin={{ right: "medium" }}
          gap="small"
        >
          {/* <Box
                align="end"
                justify="center"
                direction="row"
                //border={{ style: "ridge" }}
                elevation="none"
                round="xsmall"
              > */}
          {/*           <Tip
                  //content="Min. 3 Chars Required"
                  plain
                  dropProps={{ align: { right: "left" } }}
                  content={
                    <Box
                      align="center"
                      background="accent-1"
                      margin="xsmall"
                      pad="xsmall"
                      round="medium"
                      flex={false}
                    >
                      <Text color="red">search with 3 or more letters</Text>
                    </Box>
                  }
                >
                  <TextInput
                    // icon={<Search />}
                    reverse
                    placeholder="Search content"
                    plain={true}
                    focusIndicator={false}
                    value={this.state.searchValue}
                    suggestions={this.state.suggestions}
                    // onSelect={(event) => this._OnSrchTxtSelect(event)}
                    onChange={(event) => this._onSrchTextChange(event)}
                    onKeyPress={(event) => this._onSrchTextChange(event)}
                  />

                </Tip> */}
          {/*           <Button
            icon={<Search />}
            plain={true}
            focusIndicator={false}
            onClick={this._onSrchClick}
            disabled={!bSearchEnabled}
          /> */}
          {/* </Box> */}
          {/*         <Box round="full" overflow="hidden">
            <Button icon={<Chat />} onClick={this.openChat} tip="AI-Bot" />
          </Box> */}
          {/*    <Box round="full" overflow="hidden">
            <Button icon={<Help />} onClick={this._setHelp} tip="Help ?" />
          </Box> */}
          {isEmpl && (
            <Tip content="Create Voucher">
              <Button
                icon={<ScheduleNew />}
                onClick={this._toggleVoucherPopup}
              />
            </Tip>
          )}
          {isEventManager && isEvtsApprovedData && !isEvtsSpinner && (
            <Box round="full" overflow="hidden">
              <Button
                // a11yTitle="2 Available Updates"
                icon={<Validate color="black" />}
                onClick={this._openApprovals}
                badge
                tip="Event Management"
                hoverIndicator
              />
            </Box>
          )}
          {isEventManager && !isEvtsApprovedData && isEvtsSpinner && (
            <Box round="full" overflow="hidden" background="white">
              <Spinner size="xsmall" color="brand" />
            </Box>
          )}
          {isEventManager && !isEvtsApprovedData && !isEvtsSpinner && (
            <Box round="full" overflow="hidden">
              <Button
                icon={<Validate color="black" />}
                disabled={true}
                //onClick={this._setHelp}
                tip="Event Management"
              />
            </Box>
          )}
          {/* <Box round="full" overflow="hidden">
            <DropButton
              dropAlign={{ top: "bottom", right: "right" }}
              dropContent={
                <Box align="start" justify="center" direction="column">
                  <Box align="center" justify="center" direction="column">
                    {bIsYammer_SlackON && (
                      <Button
                        icon={<Slack size="small" color="brand" />}
                        label="Slack DemoPortal"
                        onClick={this.OpenSlackHDP}
                      />
                    )}
                    <Button label="HPE PSNow" onClick={this.OpenPSNow} />
                    <Button label="HPE TechPro" onClick={this.OpenTechPro} />
                  </Box>
                </Box>
              }
              plain={false}
              primary={false}
              hoverIndicator
              icon={<Channel />}
            />
          </Box> */}
          <Stack anchor="top-right">
            <DropButton
              onOpen={this.hideMainBannerDisplay}
              // dropAlign={{ top: "bottom", right: "right" }}
              //dropContent={
              //  <Box align="start" justify="center" direction="column">
              //  <Box
              //   align="center"
              //   justify="center"
              //   direction="column"
              //  background={{ color: "active" }}
              //  elevation="medium"
              //   round="xsmall"
              // >
              // <Text size="large" color="brand" margin="medium">
              //  {/* <mark background-color="brand" color="green"> */}
              //  {BannerMsg}
              //    {/* </mark> */}
              //  </Text>
              //  </Box>
              // </Box>
              // }
              plain={false}
              primary={false}
              hoverIndicator
              icon={<Notification />}
              reverse={false}
            />
            {!bIsBannerMsgAlreadyRead && BannerMsg.length > 1 && (
              <Box
                align="center"
                justify="center"
                pad="xsmall"
                background={{ color: "red" }}
                border={{ color: "white", size: "small" }}
                round="full"
                animation={{ type: "pulse", duration: 500 }}
              />
            )}
          </Stack>
          <DropButton
            dropAlign={{ top: "bottom", right: "right" }}
            dropContent={
              <Box align="start" justify="center">
                <Button label="My Profile" onClick={this._setProfile} />
                <Button label="Logout" onClick={this._logout} />
              </Box>
            }
          >
            <Stack anchor="top-right">
              <InitialsAvatar name={FullName} />
              {/*                   <Avatar
                    align="center"
                    flex={false}
                    justify="center"
                    overflow="hidden"
                    round="full"
                    src={uimg ? uimg : avtarPlaceholder}
                  /> */}
              <Box
                align="center"
                justify="center"
                pad="xsmall"
                background={dottie}
                border={{ color: "white", size: "small" }}
                round="full"
              />
            </Stack>
          </DropButton>
          {this.state.bDisplayVoucher && isEmpl && (
            <VoucherPopup onClose={this._toggleVoucherPopup} />
          )}
          {this.state.bOpenChat && <Chatapplet />}
        </Nav>
      </Header>
    );
  }
}

export default withRouter(AppHeader);
